import {
  Box,
  Button,
  Flex,
  Grid,
  HStack,
  Image,
  Input,
  InputGroup,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  StackDivider,
  Stat,
  StatLabel,
  StatNumber,
  Text,
  Tooltip,
} from '@chakra-ui/core';
import { InfoOutlineIcon } from '@chakra-ui/icons';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { BeatLoader } from 'react-spinners';
import HappyFace from '../assets/happy_face.svg';
import WalletImage from '../assets/wallet.svg';
import BetsTable, { BetsTableProvider } from '../components/BetsTable';
import CopyInputAddon from '../components/CopyInputAddon';
import Header from '../components/Header';
import SlidingRadio from '../components/SlidingRadio';
import UrgentActions from '../components/UrgentActions';
import WalletUnlockModal from '../components/WalletUnlockModal';
import { Bitcoin, createClient } from '../services/chainClient';
import { useAppDispatch } from '../store';
import { fetchAllBetStates, hydrateBets } from '../store/bets/betsSlice';
import { RootState } from '../store/reducers';
import { updateBalance } from '../store/wallet/walletSlice';
import { ELECTION_BETTING_END_DATE } from '../utils/Election';
import { toBTC } from '../utils/Utils';
import { ViewInfluencerBets } from './ViewInfluencerBets';
import WalletSettingsButton from './WalletSettings/WalletSettingsButton';

const UserBets = () => {
  const mnemonic = useSelector((state: RootState) => state.wallet.mnemonic);
  const bitcoinRef = useRef<Bitcoin | null>(null);

  const [twitterInfo, setTwitterInfo] = useState<any | undefined>();
  const [twitterInfoModalOpen, setTwitterInfoModalOpen] = useState(false);
  const [pubkey, setPubkey] = useState('');

  const bets = useSelector((state: RootState) => state.bets);
  const balance = useSelector((state: RootState) => state.wallet.balance);
  const balanceUpdated = useSelector(
    (state: RootState) => state.wallet.balanceUpdated
  );

  const [showWalletSettings, setShowWalletSettings] = useState(
    !!localStorage.getItem('encryptedMnemonic')
  );

  const [selectedInfluencer, setSelectedInfluencer] = useState('all');
  const [sliderSelected, setSliderSelected] = useState(false);

  // new feature modal
  const [isNewFeatureModalOpen, setIsNewFeatureModalOpen] = useState(false);

  const onSliderChange = (e) => {
    // if (e.target.checked && twitterInfo) {
    // setSelectedInfluencer(twitterInfo.screen_name);
    // }
    setSliderSelected(e.target.checked);
  };

  const dispatch = useAppDispatch();

  useEffect(() => {
    const doesMnemonicExist = !!localStorage.getItem('encryptedMnemonic');
    const twitterInfoString = localStorage.getItem('twitterInfo');

    // show wallet settings if encrypted mnemonic exists
    setShowWalletSettings(doesMnemonicExist);

    if (
      doesMnemonicExist &&
      !twitterInfoString &&
      !localStorage.getItem('shownNewFeature')
    ) {
      setIsNewFeatureModalOpen(true);
    }

    if (!twitterInfoString) return;
    const _twitterInfo = JSON.parse(twitterInfoString);
    setTwitterInfo(_twitterInfo);
    // setSelectedInfluencer(_twitterInfo.screen_name);
    console.log(_twitterInfo);
  }, []);

  useEffect(() => {
    if (!mnemonic) return;

    const bitcoin = createClient(mnemonic);
    bitcoinRef.current = bitcoin;

    bitcoinRef.current.client
      .getMethod('getAddresses')(0, 50, false)
      .then((addresses) => {
        console.log('addresses[1]', addresses[1]);
        setPubkey(addresses[1].publicKey.toString('hex'));
        bitcoin.client
          .getMethod('getUnspentTransactions')(addresses)
          .then((utxos) => {
            console.log('address utxos', utxos);
          });
      });
    bitcoinRef.current?.client
      .getMethod('getAddresses')(0, 50, true)
      .then((changeAddresses) => {
        bitcoin.client
          .getMethod('getUnspentTransactions')(changeAddresses)
          .then((utxos) => {
            console.log('changeAddress utxos', utxos);
          });
      });

    dispatch(updateBalance());
    dispatch(hydrateBets()).then(() => dispatch(fetchAllBetStates()));
  }, [dispatch, mnemonic]);

  useEffect(() => {
    console.log('updated bets', bets);
  }, [bets]);

  useEffect(() => {
    if (!mnemonic) return;
    const client = createClient(mnemonic);
    bitcoinRef.current = client;
  }, [mnemonic]);

  if (!mnemonic) return <WalletUnlockModal />;

  const activeBets = Object.values(bets).filter(
    (bet) => bet.stage === 'ACTIVE'
  );

  return (
    <BetsTableProvider>
      <Box>
        <Header h="10rem" borderRadius="0 0 2px 2px" position="relative">
          <SlidingRadio
            top={25}
            left="50%"
            transform="translate(-50%, 0)"
            position="absolute"
            onLabel="My Dashboard"
            offLabel="Browse Open Offers"
            isChecked={sliderSelected}
            onChange={onSliderChange}
          />
        </Header>
        {sliderSelected ? (
          <ViewInfluencerBets
            selectedTwitterScreenName={selectedInfluencer}
            onSelectInfluencer={(influencer) => {
              console.log('selcted', influencer);
              setSelectedInfluencer(influencer);
            }}
          />
        ) : (
          <Grid
            p={8}
            m="0 auto"
            h="100%"
            // w="70%"
            minW="1000px"
            maxW="1280px"
            transform="translate(0, -100px)"
            gridTemplateAreas='"action-required action-required"
          "user-info user-info"
      "metrics balance"
      "bets bets"'
            gap="20px 20px"
            gridTemplateColumns="1fr 1fr"
            gridTemplateRows="min-content min-content min-content 1fr"
          >
            <UrgentActions gridArea="action-required" />
            {twitterInfo && (
              <HStack
                gridArea="user-info"
                bg="white"
                p={4}
                borderRadius="4px"
                divider={<StackDivider borderColor="gray.200" />}
              >
                <Flex alignItems="center" flex={0.5}>
                  <Box
                    mx={4}
                    borderRadius={100}
                    boxSize="75px"
                    bg="#EBEBEB"
                    flexShrink={0}
                    background={`url(${twitterInfo.profile_image_url_https.replace(
                      'normal',
                      '200x200'
                    )})`}
                    backgroundSize="cover"
                  ></Box>
                  <Box>
                    <Box
                      h="20px"
                      overflow="hidden"
                      whiteSpace="nowrap"
                      fontWeight="bold"
                      textOverflow="ellipsis"
                    >
                      {twitterInfo.name}
                    </Box>
                    <Box
                      w="100%"
                      fontSize="sm"
                      overflow="hidden"
                      textOverflow="ellipsis"
                    >
                      {twitterInfo.description}
                    </Box>
                  </Box>
                  <Button
                    backgroundColor="#ffffff"
                    color="#4a4a4a"
                    onClick={() => setTwitterInfoModalOpen(true)}
                  >
                    <InfoOutlineIcon />
                  </Button>
                </Flex>
                <Flex p={4} alignItems="center" flex={0.5}>
                  <Box w="full">
                    <Text fontSize="sm">Offers Page Link</Text>
                    <InputGroup size="lg" borderRadius="8px" overflow="hidden">
                      <Input
                        isReadOnly
                        w="full"
                        value={`https://atomic.finance/odds/app/offers/${twitterInfo.screen_name}`}
                      />
                      <CopyInputAddon
                        copyValue={`https://atomic.finance/odds/app/offers/${twitterInfo.screen_name}`}
                      />
                    </InputGroup>
                  </Box>
                </Flex>
              </HStack>
            )}

            <HStack
              p={4}
              h="128px"
              gridArea="metrics"
              bg="white"
              borderRadius="4px"
              justifyContent="space-around"
              divider={<StackDivider borderColor="gray.200" />}
            >
              <Stat textAlign="center">
                <StatNumber>{activeBets.length}</StatNumber>
                <StatLabel>Total Active Bets</StatLabel>
              </Stat>
              <Stat textAlign="center">
                <StatNumber>
                  {toBTC(
                    activeBets.reduce(
                      (acc, bet) => bet.betDetails.betAmount + acc,
                      0
                    ),
                    4
                  )}{' '}
                  BTC
                </StatNumber>
                <StatLabel>Total Amount Wagered</StatLabel>
              </Stat>
              <Stat textAlign="center">
                <StatNumber>
                  {toBTC(
                    activeBets.reduce(
                      (acc, bet) =>
                        bet.betDetails.betSize - bet.betDetails.betAmount + acc,
                      0
                    ),
                    4
                  )}{' '}
                  BTC
                </StatNumber>
                <StatLabel>Potential Profits</StatLabel>
              </Stat>
            </HStack>
            <Flex
              p={4}
              borderRadius="4px"
              gridArea="balance"
              alignItems="center"
              bg="white"
            >
              <Image src={WalletImage} />
              <Stat ml="8">
                <StatLabel>
                  Wallet (Funds Locked){' '}
                  <Tooltip label="Funds Locked: These are the total funds which are locked in active bet offers waiting for both parties to approve and finalize bet.">
                    <InfoOutlineIcon />
                  </Tooltip>
                </StatLabel>
                {balanceUpdated ? (
                  <StatNumber>{toBTC(balance, 4)} BTC</StatNumber>
                ) : (
                  <BeatLoader />
                )}
              </Stat>
              {showWalletSettings && <WalletSettingsButton ml="auto" />}
            </Flex>
            <BetsTable
              showCreateOffer={new Date() < ELECTION_BETTING_END_DATE}
              bets={Object.values(bets)}
            />
          </Grid>
        )}
      </Box>

      <Modal
        isOpen={isNewFeatureModalOpen}
        onClose={() => {
          localStorage.setItem('shownNewFeature', 'true');
          setIsNewFeatureModalOpen(false);
        }}
        isCentered
      >
        <ModalOverlay>
          <ModalContent>
            <ModalHeader textAlign="center">We have good news!</ModalHeader>
            <ModalCloseButton
              onClick={() => {
                localStorage.setItem('shownNewFeature', 'true');
                setIsNewFeatureModalOpen(false);
              }}
            />
            <ModalBody textAlign="center" pb="1rem">
              <Image src={HappyFace} mx="auto" />
              <Text mt={4}>
                You can now create your own bets and odds. Click on "New Bet
                Offer" to get started.
              </Text>
            </ModalBody>
          </ModalContent>
        </ModalOverlay>
      </Modal>

      <Modal
        isOpen={twitterInfoModalOpen}
        onClose={() => setTwitterInfoModalOpen(false)}
        isCentered
      >
        <ModalOverlay>
          <ModalContent>
            <ModalHeader>Twitter Details</ModalHeader>
            <ModalCloseButton onClick={() => setTwitterInfoModalOpen(false)} />
            <ModalBody textAlign="center" pb="1rem">
              <Flex p={10} alignItems="center" flex={0.5}>
                <Box w="full">
                  <Text fontSize="sm">Pubkey</Text>
                  <InputGroup size="lg" borderRadius="8px" overflow="hidden">
                    <Input isReadOnly w="full" value={pubkey} />
                    <CopyInputAddon copyValue={pubkey} />
                  </InputGroup>
                </Box>
              </Flex>
              <Flex p={4} alignItems="center" flex={0.5}>
                <Box w="full">
                  <Text fontSize="sm">Twitter ID</Text>
                  <InputGroup size="lg" borderRadius="8px" overflow="hidden">
                    <Input isReadOnly w="full" value={twitterInfo?.id_str} />
                    <CopyInputAddon copyValue={twitterInfo?.id_str} />
                  </InputGroup>
                </Box>
              </Flex>
            </ModalBody>
          </ModalContent>
        </ModalOverlay>
      </Modal>
      {/*
        <MailchimpSubscribe url={url}/>
      */}
    </BetsTableProvider>
  );
};

export default UserBets;
